






interface LocalProps {
  value: PropOptions;
}

import Vue from 'vue';
import { PropOptions } from 'vue/types/umd';
export default Vue.extend({
  name: 'HMTabs',
  props: {
    value: {
      type: String,
      required: true,
    },
  } as LocalProps,
  methods: {
    selectTab(value: string): void {
      this.$emit('input', value);
    },
  },
});
